import CompanyStatement from './CompanyStatement';

export default CompanyStatement;
